import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="#3a2b22"
					title={"Prince of Wales Hotel"}
					image={require('./video.jpg')}
					video={{ mp4: require('./video.mp4')}}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">A new brand presence to go with their restorations.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/prince-hotel.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi provided marketing consultancy together with a rebrand, new online presence, video production and digital marketing to compliment the magnificent restoration works</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Marketing Strategy</li>
									<li>Rebrand</li>
									<li>Website <a href="https://www.princehotel.com.au" target="_blank">www.princehotel.com.au</a></li>
									<li>Custom designed for visual impact</li>
									<li>Responsive design to work on all devices</li>
									<li>Video banner to grab attention</li>
									<li>Video Production</li>
									<li>Email Newsletter</li>
									<li>Smart Phone App</li>
									<li>Google Adwords and Facebook Advertising Campaigns</li>
									<li>Graphic Design – Posters, Flyers, Signage, Business Cards, etc</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Prince Hotel Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Prince Hotel Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Prince Hotel Feature" width="100%" />
								<img src={require('./example-3.jpg')} alt="Prince Hotel Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/PrinceHotel/index.js